var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_50919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9C11.3472 9 13.25 7.09721 13.25 4.75C13.25 2.40279 11.3472 0.5 9 0.5C6.65279 0.5 4.75 2.40279 4.75 4.75C4.75 7.09721 6.65279 9 9 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.4141C5.4808 10.418 2.62892 13.2699 2.625 16.7891C2.625 17.1803 2.94212 17.4974 3.33332 17.4974H14.6666C15.0578 17.4974 15.375 17.1803 15.375 16.7891C15.3711 13.2699 12.5192 10.4179 9 10.4141Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_50919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledUserIcon);
export default __webpack_public_path__ + "static/media/FilledUserIcon.fdb6e42bdc067b7859561943cce41216.svg";
export { ForwardRef as ReactComponent };